import React, { Component } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ValidateIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class SelectWithModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: false,
            values: this.props.value,
        }
    }

    validate() {
        this.props.onValidate(this.state.values);
        this.close();

    }

    forceValidate(forceValues) {
        this.props.onValidate(forceValues);
        this.close();
    }

    onSelectMenuOpen() {
        this.setState({ modalOpenned: true });
    }

    modalOnChange(values) {
        this.setState({ values })

        if (!this.props.isMulti)
            this.forceValidate(values);
    }

    close() {
        this.setState({ modalOpenned: false })
    }

    render() {
        const { classes } = this.props;
        let selectElement;

        if (this.props.async)
            selectElement = (
                <AsyncSelect
                    autoFocus
                    {...this.props}
                    value={this.state.values}
                    closeMenuOnSelect={false}
                    menuIsOpen={true}
                    defaultMenuIsOpen={true}
                    className="full_size"
                    placeholder="Sélectionner ..."
                    menuPlacement="auto"
                    classNamePrefix="select"
                    noOptionsMessage={() => "Aucune valeur"}
                    onChange={this.modalOnChange.bind(this)}
                />
            )
        else
            selectElement = (
                <Select
                    autoFocus
                    {...this.props}
                    value={this.state.values}
                    closeMenuOnSelect={false}
                    menuIsOpen={true}
                    defaultMenuIsOpen={true}
                    className="full_size"
                    placeholder="Sélectionner ..."
                    menuPlacement="auto"
                    classNamePrefix="select"
                    noOptionsMessage={() => "Aucune valeur"}
                    onChange={this.modalOnChange.bind(this)}
                />
            )

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <Select
                    {...this.props}
                    isClearable={false}
                    onMenuOpen={this.onSelectMenuOpen.bind(this)}
                    placeholder="Sélectionner ..."
                    className="full_size"
                    menuPlacement="auto"
                    classNamePrefix="select"
                />
                <Dialog aria-labelledby="simple-dialog-title" fullScreen open={this.state.modalOpenned}
                    onClose={this.close.bind(this)}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {this.props.label}
                            </Typography>
                            <IconButton color="inherit" onClick={this.validate.bind(this)} aria-label="Validate">
                                <ValidateIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            {selectElement}
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

export default withStyles(styles)(SelectWithModal);
